<template>
    <div v-if="errors.length > 0" class="form__fields">
        <span v-for="error in errors" class="form-field__error">
            {{ error }}
        </span>
    </div>
    <div class="form__fields">
        <div class="form__subtitle form__subtitle--with-arrow" @click="toggleVisible1">
            <span>Безопасность и вождение</span>

            <span
                class="form-subtitle__arrow"
                :class="{ 'form-subtitle__arrow--active': !isVisible1 }"
            >
                <img v-svg-inline src="@/assets/icons/ui/arrow-temp.svg" />
            </span>
        </div>

        <div v-if="isVisible1" class="form__field-group">
            <UICheckbox v-model="form.abs">
                Антиблокировочная система тормозов (ABS)
            </UICheckbox>

            <UICheckbox v-model="form.glonass">
                Устройство вызова экстренных оперативных служб Эра-Глонасс
            </UICheckbox>

            <UICheckbox v-model="form.tcs">
                Антипробуксовочная система (TCS)
            </UICheckbox>

            <UICheckbox v-model="form.emergency_brake_assist">
                Система помощи при экстренном торможении
            </UICheckbox>

            <UICheckbox v-model="form.hac">
                Система помощи при старте в горку (HAC)
            </UICheckbox>

            <UICheckbox v-model="form.blind_spot_monitoring">
                Система мониторинга слепых зон
            </UICheckbox>

            <UICheckbox v-model="form.ebd">
                Система распределения тормозных усилий (EBD)
            </UICheckbox>

            <UICheckbox v-model="form.hold_lane_assist">
                Ассистент удержания автомобиля в полосе движения
            </UICheckbox>

            <UICheckbox v-model="form.isofix">
                Крепления для детского кресла ISOFIX
            </UICheckbox>

            <UICheckbox v-model="form.driver_tracking_system">
                Система слежения за состоянием водителя
            </UICheckbox>

            <UICheckbox v-model="form.rear_door_lock">
                Блокировка задних дверей
            </UICheckbox>

            <UICheckbox v-model="form.collision_avoidance_system">
                Система предотвращения столкновений
            </UICheckbox>

            <UICheckbox v-model="form.tire_pressure_monitoring">
                Система мониторинга давления в шинах
            </UICheckbox>

            <div class="form__field-group--section">
                <UICheckbox v-model="form.front_airbags">
                    Фронтальные подушки безопасности водителя и переднего пассажира
                </UICheckbox>

                <UICheckbox v-model="form.driver_knee_airbag">
                    Коленная подушка безопасности водителя
                </UICheckbox>

                <UICheckbox v-model="form.side_airbags">
                    Боковые подушки безопасности
                </UICheckbox>

                <UICheckbox v-model="form.safety_shutters">
                    Шторки безопасности
                </UICheckbox>
            </div>
        </div>
    </div>

    <div class="form__fields">
        <div class="form__subtitle form__subtitle--with-arrow" @click="toggleVisible2">
            <span>Климат</span>

            <span
                class="form-subtitle__arrow"
                :class="{ 'form-subtitle__arrow--active': !isVisible2 }"
            >
                <img v-svg-inline src="@/assets/icons/ui/arrow-temp.svg" />
            </span>
        </div>

        <div v-if="isVisible2" class="form__field-group">
            <div class="form__radio-group-section">
                <div class="radio-group-section__label">Кондиционер</div>

                <UIRadioGroup v-model="form.conditioner">
                    <UIRadio
                        v-for="option in [{ label: 'Есть', value: true }, { label: 'Нет', value: false }]"
                        :id="option.label"
                        :value="option.value"
                        :label="option.label"
                    />
                </UIRadioGroup>
            </div>

            <div class="form__radio-group-section">
                <div class="radio-group-section__label">Климат-контроль</div>

                <UIRadioGroup v-model="form.climate">
                    <template
                        v-for="option in climateOptions"
                    >
                        <UIRadio
                            :id="'climate.' + option.value"
                            :value="option.value"
                            :label="option.label"
                        />
                    </template>
                </UIRadioGroup>
            </div>
        </div>
    </div>

    <div class="form__fields">
        <div class="form__subtitle form__subtitle--with-arrow" @click="toggleVisible3">
            <span>Защита от угона</span>

            <span
                class="form-subtitle__arrow"
                :class="{ 'form-subtitle__arrow--active': !isVisible3 }"
            >
                <img v-svg-inline src="@/assets/icons/ui/arrow-temp.svg" />
            </span>
        </div>

        <div v-if="isVisible3" class="form__field-group">
            <UICheckbox v-model="form.immobilizer">
                Иммобилайзер
            </UICheckbox>

            <UICheckbox v-model="form.central_locking">
                Центральный замок
            </UICheckbox>

            <UICheckbox v-model="form.signalling">
                Сигнализация
            </UICheckbox>
        </div>
    </div>

    <div class="form__fields">
        <div class="form__subtitle form__subtitle--with-arrow" @click="toggleVisible4">
            <span>Интерьер</span>

            <span
                class="form-subtitle__arrow"
                :class="{ 'form-subtitle__arrow--active': !isVisible4 }"
            >
                <img v-svg-inline src="@/assets/icons/ui/arrow-temp.svg" />
            </span>
        </div>

        <div v-if="isVisible4" class="form__field-group">
            <div class="form__radio-group-section">
                <div class="radio-group-section__label">Салон</div>

                <UIRadioGroup v-model="form.interiortype">
                    <template
                        v-for="option in interiortypeOptions"
                    >
                        <UIRadio
                            :id="'interiortype.' + option.value"
                            :value="option.value"
                            :label="option.label"
                        />
                    </template>
                </UIRadioGroup>
            </div>

            <div class="form__radio-group-section">
                <div class="radio-group-section__label">Количество мест</div>

                <UIRadioGroup v-model="form.number_seats">
                    <template
                        v-for="option in numberSeatsOptions"
                    >
                        <UIRadio
                            :id="'number_seats.' + option.value"
                            :value="option.value"
                            :label="option.label"
                        />
                    </template>
                </UIRadioGroup>
            </div>
        </div>

        <div v-if="isVisible4" class="form__field-group">
            <UICheckbox v-model="form.panoramic_roof">
                Панорамная крыша
            </UICheckbox>

            <UICheckbox v-model="form.leather_wheel">
                Отделка кожей рулевого колеса
            </UICheckbox>

            <UICheckbox v-model="form.leather_gearshift">
                Отделка кожей рычага КПП
            </UICheckbox>

            <UICheckbox v-model="form.combination_skin">
                Комбинация натуральной и искусственной кожи в отделке сидений
            </UICheckbox>
        </div>
    </div>

    <div class="form__fields">
        <div class="form__subtitle form__subtitle--with-arrow" @click="toggleVisible5">
            <span>Комфорт</span>

            <span
                class="form-subtitle__arrow"
                :class="{ 'form-subtitle__arrow--active': !isVisible5 }"
            >
                <img v-svg-inline src="@/assets/icons/ui/arrow-temp.svg" />
            </span>
        </div>

        <div v-if="isVisible5" class="form__field-group">
            <UICheckbox v-model="form.rear_view_camera">
                Камера заднего вида
            </UICheckbox>

            <UICheckbox v-model="form.power_windows">
                Электростеклоподъемники (передние и задние)
            </UICheckbox>

            <UICheckbox v-model="form.all_round_camera">
                Камера кругового обзора
            </UICheckbox>

            <UICheckbox v-model="form.auto_parking_system">
                Система автоматической парковки
            </UICheckbox>

            <UICheckbox v-model="form.heated_wheel">
                Подогрев руля
            </UICheckbox>

            <UICheckbox v-model="form.part_folding_baskrest">
                Складывающаяся по частям спинка заднего сиденья 60:40
            </UICheckbox>

            <UICheckbox v-model="form.cruise_control">
                Круиз-контроль
            </UICheckbox>

            <UICheckbox v-model="form.rear_parking_sensors">
                Датчики парковки сзади
            </UICheckbox>

            <UICheckbox v-model="form.power_heated_mirrors">
                Зеркала с электроприводом и обогревом
            </UICheckbox>

            <UICheckbox v-model="form.front_parking_sensors">
                Датчики парковки спереди
            </UICheckbox>

            <UICheckbox v-model="form.electric_driver_seat">
                Электрорегулировка сиденья водителя
            </UICheckbox>

            <UICheckbox v-model="form.heated_seats">
                Подогрев сидений
            </UICheckbox>

            <UICheckbox v-model="form.electric_passenger_seat">
                Электрорегулировка сиденья пассажира
            </UICheckbox>

            <UICheckbox v-model="form.smart_key">
                Система "Smart key" — доступ без ключа + кнопка START/STOP
            </UICheckbox>

            <UICheckbox v-model="form.memory_settings">
                Память настроек для двух водителей (сиденье, наружные зеркала)
            </UICheckbox>

            <UICheckbox v-model="form.roof_rails">
                Рейлинги на крыше
            </UICheckbox>

            <UICheckbox v-model="form.power_tailgate">
                Электропривод двери багажника
            </UICheckbox>

            <UICheckbox v-model="form.seat_ventilation">
                Вентиляция сидений
            </UICheckbox>
        </div>

        <div v-if="isVisible5" class="form__field-group">
            <div class="form__radio-group-section">
                <div class="radio-group-section__label">Регулировка руля</div>

                <UIRadioGroup v-model="form.steering_wheel">
                    <template
                        v-for="option in steeringWheelOptions"
                    >
                        <UIRadio
                            :id="'steering_wheel.' + option.value"
                            :value="option.value"
                            :label="option.label"
                        />
                    </template>
                </UIRadioGroup>
            </div>
        </div>
    </div>

    <div class="form__fields">
        <div class="form__subtitle form__subtitle--with-arrow" @click="toggleVisible6">
            <span>Экстерьер</span>

            <span
                class="form-subtitle__arrow"
                :class="{ 'form-subtitle__arrow--active': !isVisible6 }"
            >
                <img v-svg-inline src="@/assets/icons/ui/arrow-temp.svg" />
            </span>
        </div>

        <div v-if="isVisible6" class="form__field-group">
            <div class="form__radio-group-section">
                <div class="radio-group-section__label">Диски</div>

                <UIRadioGroup v-model="form.wheels_material">
                    <template
                        v-for="option in wheelsMaterialOptions"
                    >
                        <UIRadio
                            :id="'wheels_material.' + option.value"
                            :value="option.value"
                            :label="option.label"
                        />
                    </template>
                </UIRadioGroup>
            </div>

            <UISelect
                v-model="form.wheels_size"
                :options="wheelsSizeOptions"
                label="Размер"
            />
        </div>
    </div>

    <div class="form__fields">
        <div class="form__subtitle form__subtitle--with-arrow" @click="toggleVisible7">
            <span>Мультимедиа</span>

            <span
                class="form-subtitle__arrow"
                :class="{ 'form-subtitle__arrow--active': !isVisible7 }"
            >
                <img v-svg-inline src="@/assets/icons/ui/arrow-temp.svg" />
            </span>
        </div>

        <div v-if="isVisible7" class="form__field-group">
            <UICheckbox v-model="form.native_navigation_system">
                Штатная навигационная система
            </UICheckbox>

            <UICheckbox v-model="form.bluetooth">
                Bluetooth
            </UICheckbox>

            <UICheckbox v-model="form.socket_12v">
                Розетка 12V
            </UICheckbox>

            <UICheckbox v-model="form.multifunction_steering_wheel">
                Мультифункциональное рулевое колесо
            </UICheckbox>

            <UICheckbox v-model="form.usb">
                USB
            </UICheckbox>

            <UICheckbox v-model="form.socket_220v">
                Розетка ~220V
            </UICheckbox>

            <UICheckbox v-model="form.aux">
                AUX
            </UICheckbox>
        </div>
    </div>

    <div class="form__fields">
        <div class="form__subtitle form__subtitle--with-arrow" @click="toggleVisible8">
            <span>Освещение и обзор</span>

            <span
                class="form-subtitle__arrow"
                :class="{ 'form-subtitle__arrow--active': !isVisible8 }"
            >
                <img v-svg-inline src="@/assets/icons/ui/arrow-temp.svg" />
            </span>
        </div>

        <div v-if="isVisible8" class="form__field-group">
            <UICheckbox v-model="form.rain_sensor">
                Датчик дождя
            </UICheckbox>

            <UICheckbox v-model="form.fog_lights">
                Противотуманные фары
            </UICheckbox>

            <UICheckbox v-model="form.light_sensor">
                Датчик света
            </UICheckbox>

            <UICheckbox v-model="form.headlight_washer">
                Омыватель фар
            </UICheckbox>

            <UICheckbox v-model="form.running_lights">
                Дневные ходовые огни
            </UICheckbox>
        </div>

        <div v-if="isVisible8" class="form__field-group">
            <div class="form__radio-group-section">
                <div class="radio-group-section__label">Фары</div>

                <UIRadioGroup v-model="form.headlights" column-mobile>
                    <template
                        v-for="option in headlightsOptions"
                    >
                        <UIRadio
                            :id="'headlights.' + option.value"
                            :value="option.value"
                            :label="option.label"
                        />
                    </template>
                </UIRadioGroup>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { onMounted, PropType, ref } from 'vue';

    import { SelectOption } from '@/types/form.type.ts';
    import { ComplectationOptionsUICreateForm } from '@/types/complectation.type.ts';

    import useComplectationRepository from '@/repositories/complectation/useComplectationRepository.ts';

    import UICheckbox from '@/components/ui/UICheckbox/UICheckbox.vue';
    import UISelect from '@/components/ui/UISelect/UISelect.vue';
    import UIRadio from '@/components/ui/UIRadio/UIRadio.vue';
    import UIRadioGroup from '@/components/ui/UIRadioGroup/UIRadioGroup.vue';

    const { errors } = defineProps({
        errors: {
            type: Array as PropType<string[]>,
            default: [],
        },
    });

    const form = defineModel<ComplectationOptionsUICreateForm>({
        required: true,
    });

    const { getComplectationOptionValues } = useComplectationRepository();

    const climateOptions = ref<SelectOption[]>([]);
    const interiortypeOptions = ref<SelectOption[]>([]);
    const numberSeatsOptions = ref<SelectOption[]>([]);
    const steeringWheelOptions = ref<SelectOption[]>([]);
    const wheelsMaterialOptions = ref<SelectOption[]>([]);
    const wheelsSizeOptions = ref<SelectOption[]>([]);
    const headlightsOptions = ref<SelectOption[]>([]);

    const isVisible1 = ref(true);
    const isVisible2 = ref(true);
    const isVisible3 = ref(true);
    const isVisible4 = ref(true);
    const isVisible5 = ref(true);
    const isVisible6 = ref(true);
    const isVisible7 = ref(true);
    const isVisible8 = ref(true);

    const toggleVisible1 = (): void => {
        isVisible1.value = !isVisible1.value;
    };

    const toggleVisible2 = (): void => {
        isVisible2.value = !isVisible2.value;
    };

    const toggleVisible3 = (): void => {
        isVisible3.value = !isVisible3.value;
    };

    const toggleVisible4 = (): void => {
        isVisible4.value = !isVisible4.value;
    };

    const toggleVisible5 = (): void => {
        isVisible5.value = !isVisible5.value;
    };

    const toggleVisible6 = (): void => {
        isVisible6.value = !isVisible6.value;
    };

    const toggleVisible7 = (): void => {
        isVisible7.value = !isVisible7.value;
    };

    const toggleVisible8 = (): void => {
        isVisible8.value = !isVisible8.value;
    };

    function fetchFormComplectationOptionValues(optionCode: string): Promise<SelectOption[]> {
        return new Promise((resolve) => {
            getComplectationOptionValues(optionCode).then((values: Record<string, string>) => {
                const options: SelectOption[] = [];

                Object.keys(values).forEach(valueCode => {
                    options.push({
                        label: values[valueCode],
                        value: valueCode,
                    });
                });

                resolve(options);
            });
        });
    }

    function fetchFormOptions(): void {
        fetchFormComplectationOptionValues('climate')
            .then((options: SelectOption[]) => {
                climateOptions.value = options;
            });

        fetchFormComplectationOptionValues('interiortype')
            .then((options: SelectOption[]) => {
                interiortypeOptions.value = options;
            });

        fetchFormComplectationOptionValues('number_seats')
            .then((options: SelectOption[]) => {
                numberSeatsOptions.value = options;
            });

        fetchFormComplectationOptionValues('steering_wheel')
            .then((options: SelectOption[]) => {
                steeringWheelOptions.value = options;
            });

        fetchFormComplectationOptionValues('wheels_material')
            .then((options: SelectOption[]) => {
                wheelsMaterialOptions.value = options;
            });

        fetchFormComplectationOptionValues('wheels_size')
            .then((options: SelectOption[]) => {
                wheelsSizeOptions.value = options;
            });

        fetchFormComplectationOptionValues('headlights')
            .then((options: SelectOption[]) => {
                headlightsOptions.value = options;
            });
    }

    onMounted(() => {
        fetchFormOptions();
    });
</script>
